import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "default-table-area style-two all-products" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle" }
const _hoisted_7 = { class: "text-body" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "ms-2 ps-1" }
const _hoisted_11 = { class: "fw-medium fs-14 mb-0" }
const _hoisted_12 = { class: "text-secondary" }
const _hoisted_13 = { class: "text-secondary" }
const _hoisted_14 = { class: "text-secondary" }
const _hoisted_15 = { class: "text-secondary" }
const _hoisted_16 = { class: "text-secondary" }
const _hoisted_17 = { class: "d-flex align-items-center gap-1" }
const _hoisted_18 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_19 = { class: "material-symbols-outlined fs-16 text-primary" }
const _hoisted_20 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_21 = { class: "material-symbols-outlined fs-16 text-body" }
const _hoisted_22 = { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }
const _hoisted_23 = { class: "material-symbols-outlined fs-16 text-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "position-relative table-src-form me-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search here",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ], 32),
        _createVNode(_component_RouterLink, {
          to: "/users/add-user",
          class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "py-sm-1 d-block" }, [
              _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
              _createElementVNode("span", null, "Add New User")
            ], -1)
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "User ID"),
                _createElementVNode("th", { scope: "col" }, "User"),
                _createElementVNode("th", { scope: "col" }, "Email"),
                _createElementVNode("th", { scope: "col" }, "Location"),
                _createElementVNode("th", { scope: "col" }, "Phone"),
                _createElementVNode("th", { scope: "col" }, "Projects"),
                _createElementVNode("th", { scope: "col" }, "Join Date"),
                _createElementVNode("th", { scope: "col" }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems.slice(0, 10), (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.userID
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.userID), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: item.user.image,
                        class: "wh-40 rounded-3",
                        alt: "user"
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h6", _hoisted_11, _toDisplayString(item.user.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(item.email), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.location), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.phone), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.projects), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.joinDate), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", _hoisted_18, [
                        _createElementVNode("i", _hoisted_19, _toDisplayString(item.action.view), 1)
                      ]),
                      _createElementVNode("button", _hoisted_20, [
                        _createElementVNode("i", _hoisted_21, _toDisplayString(item.action.edit), 1)
                      ]),
                      _createElementVNode("button", _hoisted_22, [
                        _createElementVNode("i", _hoisted_23, _toDisplayString(item.action.delete), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_PaginationTwo, {
          class: "p-4",
          items: "10",
          total: _ctx.items.length
        }, null, 8, ["total"])
      ])
    ])
  ]))
}